// extracted by mini-css-extract-plugin
module.exports = {"navTabs":"ActiveTabs_navTabs__1FNGT","activeTab":"ActiveTabs_activeTab__1yAfd","inactiveTab":"ActiveTabs_inactiveTab__3OnbI"};